import { render, staticRenderFns } from "./ChoosePlan.vue?vue&type=template&id=c9dc0586&scoped=true&"
import script from "./ChoosePlan.vue?vue&type=script&lang=ts&"
export * from "./ChoosePlan.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePlan.vue?vue&type=style&index=0&id=c9dc0586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dc0586",
  null
  
)

export default component.exports